import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { UpdateUser, UpdateUserDefaultValues } from 'src/app/components/users/update-user';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-edit-admin-profile',
    templateUrl: './edit-admin-profile.component.html',
    styleUrls: ['./edit-admin-profile.component.scss'],
    standalone: false
})
export class EditAdminProfileComponent {
  updateUser:UpdateUser=UpdateUserDefaultValues();
  userdbid: string = '';
  pageName=CheckPageAccess.DASHBOARDADMIN
constructor(private userservice: UserService, private route: ActivatedRoute, private toastservice: ToastService, private router: Router) { }

  ngOnInit(): void {
    this.userservice.getUserProfile().subscribe({
      next: (profile) => {
        this.userdbid = profile.id;
        this.userservice.getUserDetailsForUpdate(this.userdbid).subscribe({
          next: (response) => {
            this.updateUser = response;
          }
        });
      }
    });
  }

  onUpdate()
  {
    this.userservice.updateUser(this.updateUser).subscribe({
      next: (response) => {
        localStorage.setItem('agentname', this.updateUser.firstName+' '+this.updateUser.lastName)
        this.toastservice.showMessage('Profile updated successfully');
        this.router.navigate(['/dashboard-bb']);
      }
    })
  }
}
